export default {
  locales: [
    {
      code: 'en',
      file: 'en.js',
      name: 'En'
    },
  ],
  def: 'en'
}